// Add makeReactive as a plugin - necessary to have the vue app react to changes to a makeReactive object
import Vue from 'vue';
import { makeReactive } from '@dha/make-reactive';
import screens from '@/services/screens';

Vue.use(makeReactive);
Vue.use(screens);
